import { PageKey } from '../enums/pageKey';
import { Portal, PortalLink } from '../enums/portal.enum';
import {
  RecentGenerationMetadata,
  RecentGenerationMenuItem,
} from '../interfaces/recentGeneration';

import { PAGE_KEY_TITLES } from './pagekeyTitles';
import { routes } from './routes';

export const PAGE_KEY_TO_ROUTE_MAP: Partial<Record<PageKey, string>> = {
  [PageKey.lessonPlan]: routes.MAIN,
  [PageKey.objective]: routes.LEARNING_COMPETENCY,
  [PageKey.quizMakerSingle]: routes.QUIZMAKER,
  [PageKey.activities]: routes.ACTIVITIES,
  [PageKey.subjectExtention]: routes.SUBJECT_EXTENSIONS,
  [PageKey.analogyContextualizer]: routes.ANALOGY,
  [PageKey.dailyLessonLog]: routes.DLL,
  [PageKey.catchUpFridays]: routes.CATCH_UP_FRIDAYS,
  [PageKey.summativeTest]: routes.SUMMATIVE_TEST,
  [PageKey.cerebroLessonPlan]: routes.CEREBRO_LESSON_PLAN,
  [PageKey.topicExplorer]: routes.TOPIC_EXPLORER,
  [PageKey.energizer]: routes.ENERGIZER,
  [PageKey.elif]: routes.ELIF,
  [PageKey.photoBooth]: routes.PHOTO_BOOTH,
  [PageKey.unitPlan]: routes.UNIT_PLAN,
  [PageKey.pptMaker]: routes.PPT_MAKER,
  [PageKey.genericUnpacking]: routes.GENERIC_UNPACKING,
  [PageKey.iplanObjective]: routes.IPLAN_OBJECTIVE,
  [PageKey.multigradeLessonPlan]: routes.MULTIGRADE_LESSON_PLAN,
};

export const historyItemsMenuItems = (
  historyItems: RecentGenerationMetadata[],
): RecentGenerationMenuItem[] =>
  historyItems.map((item) => {
    const pageKey = item.pageKey;
    const featureTitle = PAGE_KEY_TITLES[pageKey];
    const route = PAGE_KEY_TO_ROUTE_MAP[pageKey];
    const portalPrefix = PortalLink[item.portal];
    const featurePath = `${portalPrefix}${route}?id=${item.id}`;

    const time = new Date(item.timestamp);

    return {
      name: featureTitle.pageTitle,
      id: item.id,
      portal: item.portal as Portal,
      href: featurePath,
      timeDisplay: time.toISOString(),
      title: item.subject || undefined,
      status: item.status,
    };
  });

export const HISTORY_ITEMS_EVENT_NAME = 'historyItemsChanged';
